<template>
  <se-modal
    :active="loyaltyModalActive"
    title="loyalty.ahaLoyaltyProgram"
    class="text-dark-gray"
    max-width="max-w-sm sm:max-w-2xl xl:max-w-3xl"
    @close="loyaltyStore.toggleLoyaltyModal(false)"
  >
    <div>
      <p>{{ $t('loyalty.signIntoSave') }}</p>
      <div class="flex w-full md:w-fit mt-3  items-center justify-start md:justify-center gap-2">
        <se-button class="w-full" @click="loyaltyStore.toggleSignInModal(true)">
          {{ $t('loyalty.signIn') }}
        </se-button>
        <se-button class="w-full" type="outline" @click="loyaltyStore.toggleRegisterModal(true)">
          {{ $t('loyalty.register') }}
        </se-button>
      </div>
    </div>
  </se-modal>
</template>

<script setup lang="ts">
import { useLoyaltyStore } from '@f/store/loyaltyStore';

const loyaltyStore = useLoyaltyStore();
const { loyaltyModalActive } = storeToRefs(loyaltyStore);
</script>
